var React = require('react');

function IconPlus (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"fill":"currentColor","x":"7","y":"0","width":"4","height":"18","rx":"2","key":0}),React.createElement("rect",{"fill":"currentColor","x":"0","y":"7","width":"18","height":"4","ry":"2","key":1})]);
}

IconPlus.defaultProps = {"viewBox":"0 0 18 18","version":"1.1"};

module.exports = IconPlus;

IconPlus.default = IconPlus;
